<vw-modal class="z-[9999]" [width]="'94%'" [height]="'auto'" [closeIcon]="'fas fa-times-circle'" [showCloseIcon]="true"
    [isOpen]="isOpen" (close)="close()" [customClasses]="'rounded-lg border shadow-xl px-4'">
    <div modalHeader>
        <div class="flex justify-between items-center py-2">
            <h2 class="text-primary-900 truncate">
                {{ 'common.modals.ai-chatbot-info-modal.title' | translate }}
            </h2>
            <vw-close-btn (click)="close()"></vw-close-btn>
        </div>
    </div>
    <div modalBody class="py-4 flex flex-col gap-2">
        <p class="text-grey-700 text-sm">
            {{ 'common.modals.ai-chatbot-info-modal.content' | translate }}
        </p>
        <p class="text-grey-700 text-sm">
            {{ 'common.modals.ai-chatbot-info-modal.content2' | translate }}
        </p>
    </div>
</vw-modal>